// Module
var code = "<button type=\"button\" style=\"border: 4px solid {{ color }};\">\n    <span style=\"color: {{ color }};\">●</span>\n    &nbsp;\n    <span id=\"keyword\">{{ text }}</span>\n</button>";
// Exports
module.exports = code;